// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2C8Zv","content":"Header_content__E9Gg6"};